import type { UnitCode } from '~/graphql/graphql';
import { formatUnitPrice, priceUnitLabel } from '~/utils';
import {
  convertPricePerUnit,
  pricedUnitFor,
  type Dimensions,
} from '~/utils/unitConversion';

export function marketMidPriceIn(
  amount: number | null | undefined,
  preferredUnit: UnitCode,
  standardUnit: UnitCode | null | undefined,
  dims: Dimensions
): { amount: number | null; unit: UnitCode } {
  if (!standardUnit) return { amount: amount ?? null, unit: preferredUnit };
  return {
    amount:
      amount == null
        ? null
        : convertPricePerUnit(amount, preferredUnit, standardUnit, dims),
    unit: pricedUnitFor(preferredUnit, standardUnit, dims),
  };
}

export function formatMarketMidPrice(
  amount: number | null | undefined,
  currency: string | undefined,
  preferredUnit: UnitCode,
  standardUnit: UnitCode | null | undefined,
  dims: Dimensions
): string | null {
  return formatPricedMarketMid(
    marketMidPriceIn(amount, preferredUnit, standardUnit, dims),
    currency
  );
}

export function formatPricedMarketMid(
  priced: { amount: number | null; unit: UnitCode },
  currency: string | undefined
): string | null {
  if (priced.amount == null) return null;
  return `${formatUnitPrice(priced.amount, currency)}/${priceUnitLabel(priced.unit)}`;
}

export function percentFromMarket(
  price: number,
  marketMid: number
): number | null {
  if (marketMid === 0) return null;
  return Math.round(((price - marketMid) / marketMid) * 1000) / 10 || 0;
}
